export const MAX_LEN_NAME = 100
export const MAX_LEN_CONTENT = 500
export const MAX_LEN_TITLE = 160